/**
 * Telefon ve e-posta baglantilari: telefon "tel:" (mobilde arama baslatir), e-posta "mailto:"
 * (e-posta istemcisini acar). Deger gecersizse undefined doner; cagiran duz metin gosterir.
 */
export function phoneHref(phone?: string | null): string | undefined {
  const raw = (phone || '').trim();
  const digits = raw.replace(/\D/g, '');
  if (digits.length < 7) return undefined;
  return `tel:${raw.startsWith('+') ? '+' : ''}${digits}`;
}

export function emailHref(email?: string | null): string | undefined {
  const value = (email || '').trim();
  return /^[^\s@<>"',;]+@[^\s@<>"',;]+\.[^\s@<>"',;.]+$/.test(value) ? `mailto:${value}` : undefined;
}
